import React from 'react';

import { Icon } from '../Icon/Icon';

interface Props {
  message: string;
}

// A small blue block with the white info icon for displaying a message to the user

export const InfoBlock = (props: Props) => {
  const {
    message,
  } = props;

  return (
    <div className="InfoBlock">
      <Icon name="ic-info-white" />
      <div>
        <p>{message}</p>
      </div>
    </div>
  );
};
